import { useQuery } from "@tanstack/react-query";
import axiosConfig from "../axiosInstance";

export const useGetAllMerchantNotifications = (enabled = true) =>
  useQuery({
    queryKey: ["getAllMerchantNotifications"],
    queryFn: async () => await axiosConfig.get(`/merchant/auth/notifications`),
    enabled,
  });

export const useGetBusinessNotifications = (businessId, enabled = true) =>
  useQuery({
    queryKey: ["getBusinessNotifications", businessId],
    queryFn: async () => await axiosConfig.get(`/business/get/notifications/${businessId}`),
    enabled: !!businessId && enabled,
  });
